export default __webpack_public_path__ + "static/assets/user_image.eb9dc346.png";